<template>
    <div class="article-title-tour">
        <h3 class="article-title-tour__title"
            :class="[ options.titlecolor ]"
            v-html="options.tourtitle"
        ></h3>
        <h4 class="article-title-tour__subtitle"
        :class="[ options.subtitlecolor ]"
            v-html="options.toursubtitle"
        ></h4>
    </div>
</template>

<script>
export default {
    name: "ArticleTitleTour",
    props: {
        options: null,
    }
}
</script>

<style lang="scss" scoped>
.article-title-tour{
    @apply relative inline-block mb-10;
     &__title {
        @apply text-5xl lg:text-6xl font-bold;
    }
     &__subtitle {
        @apply text-base lg:text-xl;
    }
}
</style>